import React,{useState,useEffect,useRef, useCallback} from "react";

// Page Components
import GeneralDetView from "../../Fragments/newItem/ItemDetail/GeneralDetView";
import ItemDescriptionView from "../../Fragments/newItem/ItemDetail/ItemDesciptionView";
import ContactView from "../../Fragments/newItem/ItemDetail/ContactView";
import ColapsePanel from "../../components/UI Components/Panels/ColapsePanel";
import ImageUploader6 from "../../components/UI Components/FileUpload/ImageUploader6";
import MessageToast from "../../components/UI Components/Messages/MessageToast";

import CustomDialog from '../../components/UI Components/Dialogs/CustomDialog';

// MUI Components
import Grid from "@mui/material/Grid";
import Box     from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CircularProgress from '@mui/material/CircularProgress';


// model
import { _mediaUpload, createObject, getDBInstance } from "../../models/model";

// Theme
import { useTheme } from '@mui/material/styles';
import {themeParams} from '../../theme/themeParams';

// Styled comp:
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";

    const SaveBtn = styled(Button)  ({
        width:'100%',
        backgroundColor: "#007095",
        alignSelf:'center',
        color:'#fff'
    });

    const FooterBar =  styled(Box)({
        bottom:10,
        position:'fixed',
        display:'flex',
        justifyContent:'space-around',
        alignItems:'center',
        height:'3rem',
        width:'90%',
        gap:3,
        backgroundColor:'#fff',
        borderTop:'1px groove',
        [`& ${SaveBtn}`] : ({ }),

        [themeParams.mediaMDUp]: {
            bottom:10,
            // position:'fixed',
            display:'flex',
           position:'relative',
           width:'100%'
        },
        
        [themeParams.mediaLGUp]: {
            bottom:10,
            // position:'fixed',
            display:'flex',
           position:'relative',
           width:'100%'
        },

        [themeParams.mediaXLUP]: {
            bottom:10,
            // position:'fixed',
            display:'flex',
           position:'relative',
           width:'100%'
        }
    });


    function NewItem2() {

    let onResetState;

    const initEntry = { 
        mediaSmall:[],
        mediaMedium:[], 
        mediaLarge:[],
        objectType: '01',
        oCity: null,
        location:{},
        city_name: "",
        city_id:"",
        price:"",
        livingSpace:"",
        numberOfRooms:"",
        numberOfBathrooms:"",
        availabilityDate: "",
        contact:{
            contactName:"",
            phone:"",
            email:""
        }
        
    }

    const FileUpldRef                      = useRef(null);
    const [tabValue,setTab]                = useState('1');
    let   [oEntry,setEntry]                = useState(initEntry);
    let   [entryState,setEntryState]       = useState({status: 0, busy:false }); //0:open | 1: saved to DB
    const [recFilesState,setResFilesState] = useState({});

    const [dialogSttng,setDialogSttng] =  useState({
        bDialogOpen: false,
        sDialogParam: '',
        bFullScreen: false
    });

    const [contact,setContact] = useState({contactName:""});

    console.log(oEntry,"entry state")

/**********************************************************************
 * STATE MANAGMENT
 ********************************************************************** */

// useEffect(() => {
//     if(!authData.isAuthenticated) {
//       let nDlgSetting = {...dialogSttng, bDialogOpen: true, sDialogParam: 'usrLgn', bFullScreen: false}
//       setDialogSttng(nDlgSetting);

//     }
// }, [])    //authData.isAuthenticated, dialogSttng


/**********************************************************************
 * EVENT HANDLING
 ********************************************************************** */

    const handleChange = (oEvent, sParam) => {

        let fname = oEvent.target ? oEvent.target.name : sParam;
        let nEntry;

        switch(fname) {

            case 'city':
                nEntry = {...oEntry,
                    'oCity'     : oEvent,
                    'city_name' : oEvent.label,
                    'city_id'   : oEvent.value,
                    'location'  : {type:'Point', coordinates:[oEvent.longitude,oEvent.latitude]}
                }
            break;

            case 'contact':
                if(!oEntry['contact']){
                    oEntry['contact'] = {};
                }

                nEntry = {...oEntry, contact: {...oEntry.contact, [`${sParam}`] : oEvent.target.value }};
                    //  ['contact'][`${sParam}`] : oEvent.target.value}

            break;

            case 'price':
                nEntry = {...oEntry, [fname]:Number(oEvent.target.value)}
                setEntry(nEntry);
            break;

            case 'livingSpace':
                nEntry = {...oEntry, [fname]:Number(oEvent.target.value)}
                setEntry(nEntry);
            break;

            case 'numberOfRooms':
                nEntry = {...oEntry, [fname]:Number(oEvent.target.value)}
                setEntry(nEntry);
            break;

            case 'numberOfBathrooms':
                nEntry = {...oEntry, [fname]:Number(oEvent.target.value)}
                setEntry(nEntry);
            break;

            default:
                nEntry = {...oEntry, [fname]:oEvent.target.value}

        }
            setEntry(nEntry);
    };

    const onSave = async (oEvent) => {
        
        let awsReq,
            awsResp,
            oNewDoc,
            srvReq,
            srvResp,
            objID,
            bValid,
            _dbInst,
            dbInst;

        try{

            oEvent.preventDefault();

            setEntryState({...entryState, busy:true});

            bValid = _validateEntry('obj_create');
            
            if(!bValid) {
                setEntryState({...entryState, busy:false});
                return
            };

            // get document instance
            _dbInst = getDBInstance('/rentals/inst');
            dbInst  = await _dbInst;

            oEntry._id         = dbInst._id;
            oEntry.mediaSmall  = [];
            oEntry.mediaMedium = [];
            oEntry.mediaLarge  = [];

            // setEntry(oEntry);

            let uploaded = await FileUpldRef.current.handleUpload(dbInst._id);

            await _prepareMedia();
            await _saveEntry();
            
            console.log(recFilesState, "upload done");

            // onResetState();

        } catch(e) {
            console.log(e);
            setEntryState({...entryState, busy:false});
            alert('Failed to create Object Data');
        }
        
    };

    const storeFileList = (filesState) => {
        setResFilesState(filesState);
    };

    onResetState = (oEvent) => {
        FileUpldRef.current.resetMedia();
        setTab('1');
        setEntry(initEntry);
    }

    const logState = () => {
        console.log(oEntry);
    }


/**********************************************************************
 * INTERNAL METHODS
 ********************************************************************** */

    const _validateEntry = (sParam) => {
        
        let bValid =  true;

        switch(sParam) {

            case 'obj_create':
               
                if(!recFilesState['stage'].resizeReady){
                    bValid = false;
                    alert('missing media');
                };

            break;

            default: //
        }

        return(bValid);
    }


    const _prepareMedia = async () => {
        recFilesState['fileList'].forEach(oFile => {
            oEntry.mediaSmall.push(oFile.uploadUrls[0]);
            oEntry.mediaMedium.push(oFile.uploadUrls[1]);
            oEntry.mediaLarge.push(oFile.uploadUrls[2]);   
        });
    };

    const _saveEntry = async () => {

        let srvReq,
            srvResp;

        try{
            srvReq  = createObject(oEntry);
            srvResp = await srvReq; 
            setEntryState({...entryState, status:1, busy:false }) // set status to completed
            alert('entry has been saved successfuly');  

        } catch(e) {
            console.log(e);
            alert('couldnt save object')
        }
    };

/**********************************************************************
 * JSX View
 ********************************************************************** */
    
    return(
        <Box>
            <Tabs
                sx={{position:'sticky', padding:0}}
                value={tabValue} //tabValue
                onChange={(oEvent, value) => { setTab(value) }} 
                centered
                variant="fullWidth">
                <Tab size="small" label="General" value="1" sx={{ padding:0}} />  
                <Tab size="small" label="Further"  value="2" sx={{ padding:0}}/>
                <Tab  size="small" label="Media"    value="3" sx={{ padding:0}}/>
            </Tabs>

            <Grid container sx={{paddingBottom:'5rem',minHeight:'70vh'}}>

                    <Grid // General Detail
                        size={{ xs: 12, md: 12, lg:12 }} 
                        sx={{marginBottom:'1rem', display:()=>{ return(tabValue === '1' ? 'block' : 'none' )} }}>
                            {<GeneralDetView handleChange={handleChange} oEntry={oEntry}/>}
                    </Grid>

                     <Grid // Item Description
                        size={{ xs: 12, md: 12, lg:12 }} 
                        sx={{marginBottom:'5rem', display:()=>{ return(tabValue === '1' ? 'block' : 'none' )} }}>
                            {/* {<ItemDescriptionView handleChange={handleChange}/>} */}
                    </Grid>

                    <Grid // Contact Detail
                        size={{ xs: 12, md: 12, lg:12 }} 
                        sx={{marginBottom:'1rem', display:()=>{ return(tabValue === '2' ? 'block' : 'none' )} }}>
                            {<ContactView handleChange={handleChange} oEntry={oEntry}/>}
                    </Grid>

                    <Grid // Images
                        size={{ xs: 12, md: 12, lg:12 }}
                        sx={{marginBottom:'1rem', display:()=>{ return(tabValue === '3' ? 'block' : 'none' )}}}>
                        <ImageUploader6 ref={FileUpldRef} provideFileList={storeFileList}/>
                    </Grid>

                    {/* User Messages */}
                    {/* { fileState.uploadReady ? <MessageToast bOpen={true} sMessage={'images uploaded!'}/> : null }
                    { entryState.status === 1 ? <MessageToast bOpen={true} sMessage={'entry saved!'}/> : null } */}
                    
                </Grid>
                <FooterBar>
                    <SaveBtn loading={entryState.busy}  onClick={onSave}>Save</SaveBtn>
                    <Button variant={"contained"} color={"error"} onClick={onResetState}>reset</Button>  
                    <Button variant={"contained"} color={"warning"} onClick={logState}>log</Button>       
                </FooterBar> 

              <CustomDialog
                  dialogSttng={dialogSttng}
                  handleDlgClose={() =>setDialogSttng({...dialogSttng, bDialogOpen:false})}>
              </CustomDialog>
        </Box>
        );
    }

    export default NewItem2;